// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button img[data-v-88532dce]{filter:invert(100%)}", ""]);
// Exports
module.exports = exports;
